import { Styles } from "../../config"

const styles = {
	display: "flex",
	color: Styles.Color.primary,

	"&:hover": {
		color: Styles.Color.secondary
	}
}

export default styles
